import Input from "./Input";
import { useState, useEffect } from "react";

export default function AddressCard({ usersData }) {
  return (
    <div className="w-full max-w-3xl rounded-2xl p-4 flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <span className="font-medium text-xl text-zi-text-light dark:text-zi-text-dark">
          اطلاعات آدرس
        </span>
      </div>

      <form className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-6">
        <Input
          label="کشور"
          inputSample={usersData?.userinfo?.country || ""}
          value={usersData?.userinfo?.country || ""}
          type="text"
          id="country"
          name="country"
          isReadOnly={true}
          isAuotComplete={true}
        />
        <Input
          label="شهر"
          inputSample={usersData?.userinfo?.city || ""}
          value={usersData?.userinfo?.city || ""}
          type="text"
          id="city"
          name="city"
          isReadOnly={true}
          isAuotComplete={true}
        />
        <Input
          label="آدرس"
          inputSample={usersData?.userinfo?.address || ""}
          value={usersData?.userinfo?.address || ""}
          type="text"
          id="address"
          name="address"
          isReadOnly={true}
          isAuotComplete={true}
        />
        <Input
          label="کد پستی"
          inputSample={usersData?.userinfo?.postal_code || ""}
          value={usersData?.userinfo?.postal_code || ""}
          type="text"
          id="postal"
          name="postal"
          isReadOnly={true}
          isAuotComplete={true}
        />
      </form>
    </div>
  );
}
